type SlackLogoProps = {
  className?: string
}

export function SlackLogo({
  className = 'h-10 w-10',
}: SlackLogoProps) {
  return (
    <img
      alt="Slack"
      className={`object-contain ${className}`}
      src="/integrations/slack_icon.jpg"
    />
  )
}
